export default __webpack_public_path__ + "static/pwc-helvetica-neue-400-2d8377e17393dd8c0d446797850b576b.woff2";